export enum RefundTypes {
  NONE = 'NONE',
  FULL = 'FULL',
  PARTIAL = 'PARTIAL',
}
